import { render } from "./TableThreeColumn.vue?vue&type=template&id=04afbd04"
import script from "./TableThreeColumn.vue?vue&type=script&lang=js"
export * from "./TableThreeColumn.vue?vue&type=script&lang=js"

import "./TableThreeColumn.vue?vue&type=style&index=0&id=04afbd04&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__